import styled, { css } from 'styled-components';

export const Aside = styled.aside`
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 20px 22px;

  h4 {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 4px;
  }

  hr {
    border: none;
    border-top: 1px solid #eef2f7;
    margin: 12px 0;
  }
`;

export const IconButton = styled.button<{ $danger?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  & + & {
    margin-left: 6px;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    ${({ $danger }) =>
      $danger
        ? css`
            background: #fef2f2;
            border-color: #b91c1c;
            color: #b91c1c;
          `
        : css`
            background: #f8fafc;
            border-color: #006633;
            color: #006633;
          `}
  }
`;

export const CreateButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: #006633;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
  font-family: inherit;

  &:hover {
    background: #00451f;
  }
`;

export const CategoryCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;

  .icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: #e6f3ec;
    color: #006633;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .title {
    font-weight: 700;
    color: #0f172a;
    font-size: 13.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MutedText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #475569;
  font-size: 13px;
`;

export const EmptyText = styled.span`
  color: #94a3b8;
  font-style: italic;
  font-size: 13px;
`;

export const IconPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  font-size: 12px;
  color: #475569;
  font-weight: 500;

  .glyph {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #e6f3ec;
    color: #006633;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;
